/**
 * @generated SignedSource<<e852396b3084beb853544a9a316b46d3>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ProductizedServiceCardDetails_productizedService$data = {
  readonly title: string;
  readonly " $fragmentSpreads": FragmentRefs<"ProductizedServiceCardExampleProjects_productizedService">;
  readonly " $fragmentType": "ProductizedServiceCardDetails_productizedService";
};
export type ProductizedServiceCardDetails_productizedService$key = {
  readonly " $data"?: ProductizedServiceCardDetails_productizedService$data;
  readonly " $fragmentSpreads": FragmentRefs<"ProductizedServiceCardDetails_productizedService">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ProductizedServiceCardDetails_productizedService",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ProductizedServiceCardExampleProjects_productizedService"
    }
  ],
  "type": "ProductizedService",
  "abstractKey": null
};

(node as any).hash = "03bea499cad947324142a57b1fcee643";

export default node;
